import { render, staticRenderFns } from "./MaleAndFemaleReport.vue?vue&type=template&id=2fdcdd17"
import script from "./MaleAndFemaleReport.vue?vue&type=script&lang=js"
export * from "./MaleAndFemaleReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports